import { axiosPost, axiosGet } from "../../react_axios/Axios";
import {
  platform,
  headers,
  insertMemberRegistrationUrl,
  INSERT_MEMBER_REGISTRATION,
  updateMemberRegistrationUrl,
  UPDATE_MEMBER_REGISTRATION,
  getMemberBuisnessRegistrationUrl,
  getMemberRegistrationUrl,
  GET_MEMBER_BUISNESS_REGISTRATION,
  GET_MEMBER_REGISTRATION,
  getIncompleteMemberBuisnessRegistrationUrl,
  getIncompleteMemberRegistrationUrl,
  GET_INCOMPLETE_MEMBER_BUISNESS_REGISTRATION,
  insertUpdatePaymentUrl,
  INSERT_UPDATE_PAYMENT,
  GET_INCOMPLETE_MEMBER_REGISTRATION,
  getMemberPaymentDetailsUrl,
  GET_MEMBER_PAYMENT_DETAILS,
  fetchAuthReport,
  registrationPreviewName,
  REGISTRATION_PREVIEW,
  deleteRegistrationDocumentUrl,
  DELETE_REGISTRATION_DOCUMENT,
  checkAvailableUsernameUrl,
  CHECK_AVAILABLE_USERNAME,
} from "../../utils/constants";

export const insertMemberRegistration_action =
  (
    MemberID,
    MembershipNo,
    CompanyName,
    CompanyWebsite,
    IndustryID,
    EstablishmentYear,
    Address1,
    Address2,
    City,
    State,
    CountryID,
    Title,
    ContactPersonName,
    ContactPersonDesignation,
    EmailAddress,
    PhoneNumber,
    SameAsCorrespondance,
    INVCompanyName,
    INVCompanyWebsite,
    INVIndustryID,
    INVEstablishmentYear,
    INVAddress1,
    INVAddress2,
    INVCity,
    INVState,
    INVCountryID,
    INVTitle,
    INVContactPersonName,
    INVContactPersonDesignation,
    INVEmailAddress,
    INVPhoneNumber,
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          MemberID: MemberID,
          MembershipNo: MembershipNo,
          CompanyName: CompanyName,
          CompanyWebsite: CompanyWebsite,
          IndustryID: 1,
          EstablishmentYear: EstablishmentYear,
          Address1: Address1,
          Address2: Address2,
          City: City,
          State: State,
          CountryID: CountryID,
          Title: Title,
          ContactPersonName: ContactPersonName,
          ContactPersonDesignation: ContactPersonDesignation,
          EmailAddress: EmailAddress,
          PhoneNumber: PhoneNumber,
          SameAsCorrespondance: SameAsCorrespondance,

          INVCompanyName: INVCompanyName,
          INVCompanyWebsite: INVCompanyWebsite,
          INVIndustryID: 1,
          INVEstablishmentYear: INVEstablishmentYear,
          INVAddress1: INVAddress1,
          INVAddress2: INVAddress2,
          INVCity: INVCity,
          INVState: INVState,
          INVCountryID: INVCountryID,
          INVTitle: INVTitle,
          INVContactPersonName: INVContactPersonName,
          INVContactPersonDesignation: INVContactPersonDesignation,
          INVEmailAddress: INVEmailAddress,
          INVPhoneNumber: INVPhoneNumber,
        };
        // console.log("registrationFormAddUrl", registrationFormAddUrl)
        console.log("mapdata", mapdata);

        const res = await axiosPost(insertMemberRegistrationUrl, mapdata);
        console.log("registrationOneAdd_action res", res);

        dispatch({
          type: INSERT_MEMBER_REGISTRATION,
          payload: res,
        });

        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const updateMemberRegistration_action =
  (
    MemberID,
    GSTNo,
    PANNo,
    buisnessSectorList,
    exportMarketsList,
    primaryServicesList,
    annualRevenue,
    documentsList,
    OtherBusinessSector,
    OtherPrimaryServices,
    primaryProduct
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          MemberID: MemberID,
          GSTNo: GSTNo,
          PANNo: PANNo,
          buisnessSectorList: buisnessSectorList,
          exportMarketsList: exportMarketsList,
          primaryServicesList: primaryServicesList,
          AnnualRevenue: annualRevenue,
          documentsList: documentsList,
          OtherBusinessSector: OtherBusinessSector,
          OtherPrimaryServices: OtherPrimaryServices,
          PrimaryServices: primaryProduct,
        };
        // console.log("registrationFormAddUrl", registrationFormAddUrl)
        console.log("mapdata", mapdata);

        const res = await axiosPost(updateMemberRegistrationUrl, mapdata);
        console.log("registrationOneAdd_action res", res);

        dispatch({
          type: UPDATE_MEMBER_REGISTRATION,
          payload: res,
        });

        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const insertUpdatePayment_action =
  (
    MemberID,
    IsDisclaimer,
    IsRules,
    PromocodeID,
    Promocode,
    IsOnline,
    Username,
    toPay
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          MemberID: MemberID,
          IsDisclaimer: IsDisclaimer,
          IsRules: IsRules,
          PromocodeID: PromocodeID,
          Promocode: Promocode,
          IsOnline: IsOnline,
          Username: Username,
          toPay: toPay,
        };
        // console.log("registrationFormAddUrl", registrationFormAddUrl)
        console.log("mapdata", mapdata);

        const res = await axiosPost(insertUpdatePaymentUrl, mapdata);
        console.log("registrationOneAdd_action res", res);

        dispatch({
          type: INSERT_UPDATE_PAYMENT,
          payload: res,
        });

        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const getMemberRegistration_action =
  (AccountID, MemberID) => async (dispatch) => {
    try {
      const mapdata = {
        AccountID: AccountID,
        MemberID: MemberID,
      };
      // console.log("registrationFormAddUrl", registrationFormAddUrl)
      console.log("mapdata", mapdata);

      const res = await axiosGet(getMemberRegistrationUrl, mapdata);
      console.log("registrationOneAdd_action res", res);

      dispatch({
        type: GET_MEMBER_REGISTRATION,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getMemberBuisnessRegistration_action =
  (AccountID, MemberID) => async (dispatch) => {
    try {
      const mapdata = {
        AccountID: AccountID,
        MemberID: MemberID,
      };
      // console.log("registrationFormAddUrl", registrationFormAddUrl)
      console.log("mapdata", mapdata);

      const res = await axiosGet(getMemberBuisnessRegistrationUrl, mapdata);
      console.log("registrationOneAdd_action res", res);

      dispatch({
        type: GET_MEMBER_BUISNESS_REGISTRATION,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getIncompleteMemberRegistration_action =
  (AccountID, UUID) => async (dispatch) => {
    try {
      const mapdata = {
        AccountID: AccountID,
        UUID: UUID,
      };
      // console.log("registrationFormAddUrl", registrationFormAddUrl)
      console.log("mapdata", mapdata);

      const res = await axiosGet(getIncompleteMemberRegistrationUrl, mapdata);
      console.log("registrationOneAdd_action res", res);

      dispatch({
        type: GET_INCOMPLETE_MEMBER_REGISTRATION,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getIncompleteMemberBuisnessRegistration_action =
  (AccountID, UUID) => async (dispatch) => {
    try {
      const mapdata = {
        AccountID: AccountID,
        UUID: UUID,
      };
      // console.log("registrationFormAddUrl", registrationFormAddUrl)
      console.log("mapdata", mapdata);

      const res = await axiosGet(
        getIncompleteMemberBuisnessRegistrationUrl,
        mapdata
      );
      console.log("registrationOneAdd_action res", res);

      dispatch({
        type: GET_INCOMPLETE_MEMBER_BUISNESS_REGISTRATION,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getMemberPaymentDetails_action =
  (MemberID, Promocode) => async (dispatch) => {
    try {
      const mapdata = {
        MemberID: MemberID,
        Promocode: Promocode,
      };

      const res = await axiosGet(getMemberPaymentDetailsUrl, mapdata);
      console.log("registrationOneAdd_action res", res);

      dispatch({
        type: GET_MEMBER_PAYMENT_DETAILS,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const deleteRegistrationDocument_action =
  (MemberID, FileType) => async (dispatch) => {
    try {
      const mapdata = {
        MemberID: MemberID,
        FileType: FileType,
      };
      // console.log("registrationFormAddUrl", registrationFormAddUrl)
      console.log("mapdata", mapdata);

      const res = await axiosGet(deleteRegistrationDocumentUrl, mapdata);
      console.log("registrationOneAdd_action res", res);

      dispatch({
        type: DELETE_REGISTRATION_DOCUMENT,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const registrationPreview_action = (MemberID) => async (dispatch) => {
  try {
    var list = [];
    const mapdata1 = {
      ParameterName: "@MemberID",
      ParameterValue: MemberID,
      ParameterDataType: "int",
    };

    list.push(mapdata1);

    const mapData = {
      report_name: registrationPreviewName,
      parameter_details: list,
    };
    const res = await axiosPost(fetchAuthReport, mapData);

    dispatch({
      type: REGISTRATION_PREVIEW,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const checkAvailableUsername_action = (username) => async (dispatch) => {
  try {
    const mapdata = { username };
    const res = await axiosGet(checkAvailableUsernameUrl, mapdata);
    console.log(res, 'ressssssssss')
    dispatch({
      type: CHECK_AVAILABLE_USERNAME,
      payload: res.data ? res.data : res,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    console.error("AXIOS ERROR:", err);

    if (err?.response?.data) {
      return Promise.reject(err.response.data);
    } else {
      return Promise.reject({ msg: "Username Already Exist" });
    }
  }
};